module.exports = __webpack_public_path__ + "img/tinteccnc_history.fddfdcd3.svg";